import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./InlineSelectorWrapper.module.css";
import classNames from "classnames";
import CloseSvg from "src/components/svg/CloseSvg";
import { SelectorWrapperHeading } from "src/components/selectorwrapper/SelectorWrapper";

//#region [Props]
type InlineSelectorWrapperProps = {
  children: React.ReactNode;
  onClose: () => void;
  heading?: string;
  className?: string;
  hideClose: false;
} | {
  children: React.ReactNode;
  hideClose?: true;
  className?: string;
  onClose?: () => void;
  heading?: string;
};
//#endregion

//#region [Component]
export default function InlineSelectorWrapper(t0) {
  const $ = _c(16);
  const {
    className,
    children,
    onClose,
    heading,
    hideClose: t1
  } = t0;
  const hideClose = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== hideClose || $[1] !== onClose) {
    t2 = () => {
      if (!hideClose) {
        const escHandler = evt => {
          if (evt.code === "Escape") {
            onClose?.();
          }
        };
        document.addEventListener("keydown", escHandler, false);
        return () => {
          document.removeEventListener("keydown", escHandler, false);
        };
      }
    };
    t3 = [onClose, hideClose];
    $[0] = hideClose;
    $[1] = onClose;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== className) {
    const themeStyles = getThemeStyles(styles);
    t4 = classNames(styles.InlineSelectorWrapper, themeStyles, className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hideClose || $[7] !== onClose) {
    t5 = !hideClose && <button className={styles.SCloseButton} onClick={onClose}><CloseSvg /></button>;
    $[6] = hideClose;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== heading) {
    t6 = heading && <SelectorWrapperHeading heading={heading} />;
    $[9] = heading;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t4} onClick={_temp}>{t5}{t6}{children}</div>;
    $[11] = children;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
//#endregion
function _temp(e) {
  return e.stopPropagation();
}